import React, { Component } from "react";
import NivoPie from "../../../../components/Pie/NivoPie";
export default class PieChart extends Component {
  render() {
    return (
      <div
        style={{
          width: this.props.width || "900px",
          height: this.props.height || "500px",
        }}
      >
        <NivoPie
          data={this.props.data}
          type={this.props.type}
          legend={true}
        ></NivoPie>
        <div
          style={{
            textAlign: "center",
            marginTop: this.props.type === "GiaoThong" ? "-20px" : "-28px",
            fontSize: "12px",
            fontFamily: "sans-serif",
            color: "rgb(51, 51, 51)",
            marginRight: "90px",
          }}
        >
          {this.props.title}
        </div>
      </div>
    );
  }
}
